import { PropertyTypes, PropertyUsages } from ".";

export type DecisionCriteriaMismatchCode =
  | DecisionCriteriaMismatchCodes.Borrower
  | DecisionCriteriaMismatchCodes.Property
  | DecisionCriteriaMismatchCodes.MaxLoanAmount
  | DecisionCriteriaMismatchCodes.NeededLoanAmount;

export type DecisionCriteriaMismatchReason =
  | DecisionCriteriaMismatchReasons.CreditScore
  | DecisionCriteriaMismatchReasons.PropertyType
  | DecisionCriteriaMismatchReasons.PropertyUsage
  | DecisionCriteriaMismatchReasons.MaxLoanTooLow
  | DecisionCriteriaMismatchReasons.NeededLoanAmountTooLow
  | DecisionCriteriaMismatchReasons.NeededLoanAmountTooHigh;

export type DecisionCriteriaMismatchExpectationLabel =
  | DecisionCriteriaMismatchExpectationLabels.AllowedValues
  | DecisionCriteriaMismatchExpectationLabels.MaximumValue
  | DecisionCriteriaMismatchExpectationLabels.MinimumValue;

export enum DecisionCriteriaMismatchCodes {
  Borrower = "MismatchBorrower",
  Property = "MismatchProperty",
  MaxLoanAmount = "MismatchMaxLoanAmount",
  NeededLoanAmount = "MismatchNeededLoanAmount",
}

export enum DecisionCriteriaMismatchReasons {
  CreditScore = "CreditScore",
  PropertyType = "PropertyType",
  PropertyUsage = "PropertyUsage",
  MaxLoanTooLow = "MaxLoanTooLow",
  NeededLoanAmountTooLow = "NeededLoanAmountTooLow",
  NeededLoanAmountTooHigh = "NeededLoanAmountTooHigh",
}

export enum DecisionCriteriaMismatchExpectationLabels {
  AllowedValues = "AllowedValues",
  MaximumValue = "MaximumValue",
  MinimumValue = "MinimumValue",
}

export interface DecisionCriteriaMismatchNeededLoanAmountLowExplainer {
  reason: DecisionCriteriaMismatchReasons.NeededLoanAmountTooLow;
  expectation_label: DecisionCriteriaMismatchExpectationLabels.MinimumValue;
  expectation: string;
  actual: string;
}

export interface DecisionCriteriaMismatchNeededLoanAmountHighExplainer {
  reason: DecisionCriteriaMismatchReasons.NeededLoanAmountTooHigh;
  expectation_label: DecisionCriteriaMismatchExpectationLabels.MaximumValue;
  expectation: string;
  actual: string;
}

export interface DecisionCriteriaMismatchMaxLoanAmountLowExplainer {
  reason: DecisionCriteriaMismatchReasons.MaxLoanTooLow;
  expectation_label: DecisionCriteriaMismatchExpectationLabels.MinimumValue;
  expectation: string;
  actual: string;
}

export interface DecisionCriteriaMismatchPropertyTypeExplainer {
  reason: DecisionCriteriaMismatchReasons.PropertyType;
  expectation_label: DecisionCriteriaMismatchExpectationLabels.AllowedValues;
  expectation: PropertyTypes[];
  actual: string;
}

export interface DecisionCriteriaMismatchPropertyUsageExplainer {
  reason: DecisionCriteriaMismatchReasons.PropertyUsage;
  expectation_label: DecisionCriteriaMismatchExpectationLabels.AllowedValues;
  expectation: PropertyUsages[];
  actual: string;
}

export interface DecisionCriteriaMismatchCreditScoreExplainer {
  reason: DecisionCriteriaMismatchReasons.CreditScore;
  expectation_label: DecisionCriteriaMismatchExpectationLabels.MinimumValue;
  expectation: number;
  actual: number;
}

export type DecisionCriteriaMismatch =
  | DecisionCriteriaMismatchBorrower
  | DecisionCriteriaMismatchProperty
  | DecisionCriteriaMismatchMaxLoanAmount
  | DecisionCriteriaMismatchNeededLoanAmount;

export interface DecisionCriteriaMismatchBorrower {
  code: DecisionCriteriaMismatchCodes.Borrower;
  explainer: DecisionCriteriaMismatchCreditScoreExplainer[];
}

export interface DecisionCriteriaMismatchProperty {
  code: DecisionCriteriaMismatchCodes.Property;
  explainer: (
    | DecisionCriteriaMismatchPropertyTypeExplainer
    | DecisionCriteriaMismatchPropertyUsageExplainer
  )[];
}

export interface DecisionCriteriaMismatchMaxLoanAmount {
  code: DecisionCriteriaMismatchCodes.MaxLoanAmount;
  explainer: DecisionCriteriaMismatchMaxLoanAmountLowExplainer[];
}

export interface DecisionCriteriaMismatchNeededLoanAmount {
  code: DecisionCriteriaMismatchCodes.NeededLoanAmount;
  explainer: (
    | DecisionCriteriaMismatchNeededLoanAmountLowExplainer
    | DecisionCriteriaMismatchNeededLoanAmountHighExplainer
  )[];
}
